
import { NoseurObject } from "@rivtn/noseur";
import { BaseService } from "../BaseService";
import { LzEncryptor } from "../../utils";

export interface IPageDesign {
    id: string;
    name: string;
    plan_level: number;
    preview_image: string;
    colors?: NoseurObject<string>;
}

export interface ActivePageDesign {
    design_id: string;
    scheme_settings?: {
        colors?: NoseurObject<string>;
    } & NoseurObject<string>;
}

export class UserLandService extends BaseService {

    protected static instance: UserLandService;
    static BASE_URL = process.env.REACT_APP_OMNEHOST_USERLAND_BASE_URL ?? "http://localhost:3902";
    static PREVIEW_PATH_MAP: NoseurObject<string> = {
        team: "te",
        host: "ho",
        member: "me",
        tournament: "to",
    };

    static getInstance() {
        if (!UserLandService.instance) UserLandService.instance = new UserLandService();
        return UserLandService.instance;
    }

    getPreviewUrl(designType: string, publicId: string, pageDesign: IPageDesign, activeDesign?: ActivePageDesign, searchParams?: NoseurObject<any>) {
        return `${UserLandService.BASE_URL}/${UserLandService.PREVIEW_PATH_MAP[designType] ?? "__"}/${publicId}?` + (new URLSearchParams({
            ...searchParams,
            ds_colors: JSON.stringify(activeDesign?.scheme_settings?.colors ?? {}),
            pp: LzEncryptor.encrypt(JSON.stringify({
                id: pageDesign.id,
                key: "dsjhgsjdhjshdkjhskjdhkj" // generate and actually validate
            }), true)
        })).toString();
    }

    getUserLandDesigns(designType: string): Promise<any> {
        if (process.env.REACT_APP_ENV === "local") {
            return this.report(this.transport.get(`${UserLandService.BASE_URL}/registry/${designType}.json`));
        }
        return this.report(this.transport.post(`/v1/router/request?${designType}`, {
            method: "GET",
            url: `${UserLandService.BASE_URL}/registry/${designType}.json`
        }, { cache: true }));
    }

}
